import * as React from 'react';
import WarningMessage from './components/WarningMessage';
import { getStoreState, storeDispatch } from '../state/Store';
import * as Actions from '../state/actions';
import { STANDARDS } from '../data/Resolution';
import { Overlay } from '../components/Overlay';

interface State {
  name: string;
  width: number;
  height: number;
  isAdding: boolean;
}

export default class extends React.Component<{}, State> {
  constructor(props: any) {
    super(props);

    this.state = {
      name:
        'Custom ' + (getStoreState().app.user!.customResolutions.length + 1),
      width: 10,
      height: 10,
      isAdding: false
    };
  }

  onNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ name: e.currentTarget.value });
  };

  onWidthChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ width: parseInt(e.currentTarget.value, 10) });
  };

  onHeightChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ height: parseInt(e.currentTarget.value, 10) });
  };

  doAdd = () => {
    const { name, width, height } = this.state;
    this.setState({ isAdding: true }, () => {
      storeDispatch(Actions.addResolution({ name, width, height }));
    });
  };

  render() {
    let alreadyExists = false;
    let user = getStoreState().app.user!;
    let existingOptions = user.customResolutions.concat(STANDARDS);
    for (let i = 0; i < existingOptions.length; i++) {
      const r = existingOptions[i];
      if (r.width === this.state.width && r.height === this.state.height) {
        alreadyExists = true;
        break;
      }
    }

    const canAdd =
      !alreadyExists &&
      !this.state.isAdding &&
      this.state.name.trim().length > 0 &&
      this.state.width > 10 &&
      this.state.height > 10;

    return (
      <Overlay title="Add custom size">
        <div className="add-resolution-overlay">
          <div>
            <label>Name:</label>
            <input
              type="text"
              placeholder="Size name"
              value={this.state.name}
              onChange={this.onNameChange}
            />
          </div>
          <div>
            <label>Width:</label>
            <input
              type="number"
              min={10}
              max={1920}
              value={this.state.width}
              onChange={this.onWidthChange}
            />
            <label>Height:</label>
            <input
              type="number"
              min={10}
              max={1920}
              value={this.state.height}
              onChange={this.onHeightChange}
            />
          </div>
          {alreadyExists && (
            <WarningMessage>This size is already available.</WarningMessage>
          )}
          <button
            className="primary large"
            disabled={!canAdd}
            onClick={this.doAdd}
          >
            Add
          </button>
        </div>
      </Overlay>
    );
  }
}



// WEBPACK FOOTER //
// ./src/showcase/AddResolutionDialog.tsx